import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="pickup"
export default class extends Controller {
  static outlets = [ "ticket" ]

  static targets = ["submit", "dismiss", "saveBtn", "card", "confirm", "body", "cancel"]

  updateSummary(){
    this.ticketOutlets.forEach((ticket, index) => {
      var id = this.ticketOutlets[index].idValue

      if (this.ticketOutlets[index].qtyTarget.value > 0){
      document.getElementById('summary-qty-' + id).innerHTML = this.ticketOutlets[index].qtyTarget.value
      }
      else {
        document.getElementById('summary-' + id).classList.add('d-none')
      }
    })
  }

  resetSummary(){
    this.ticketOutlets.forEach((ticket) => {
      var id = ticket.idValue
      var summary = document.querySelector('#summary-' + id)
      setTimeout(() => {
        if (summary) {
        summary.classList.remove('d-none')
      }
      }, 500)
    })
    
  }

  buildPickup(ticket){
    var quantity = this.ticketOutlets[ticket].qtyTarget.value
    if (quantity > 0) {
        var pickup = {}
        pickup.quantity = quantity
        pickup.id = this.ticketOutlets[ticket].idValue
        pickup.type = this.ticketOutlets[ticket].typeValue
        pickup.notes = document.getElementById('summary-notes-' + this.ticketOutlets[ticket].idValue).value
    };
    return pickup
  }

  groupTicketPickups(){
    var ticket_pickups = []
    this.ticketOutlets.forEach((ticket, index) => {
      var pickup = this.buildPickup(index)
      if (pickup){
      ticket_pickups.push(pickup)}
    })
    document.getElementById('ticket_pickups').value = JSON.stringify(ticket_pickups)
    this.submitTarget.click()
    this.confirmTarget.innerHTML = "Saving..."
    this.confirmTarget.disabled = true
    this.dismissTarget.classList.add('d-none')
    this.cancelTarget.classList.add('d-none')
    this.bodyTarget.innerHTML = "Please wait. Saving in progress."
    this.bodyTarget.classList.add('p-5')
  }

  toggleSaveButton(){
    var disabled = []
    this.boothInstructions = document.querySelector('.booth-instructions');
    this.ticketOutlets.forEach((ticket, index) => {
      disabled.push(Boolean(this.ticketOutlets[index].qtyTarget.value != 0))
    })
    const isTrue = (element) => element == true;
    this.saveBtnTargets.forEach(btn => {
      if (disabled.some(isTrue)){
          btn.disabled = false;
          if (this.boothInstructions) { this.boothInstructions.classList.add('d-none'); }
          btn.classList.remove('d-none');
        }
        else {
          btn.disabled = true
          btn.classList.remove('btn-solid-primary')
          if (this.boothInstructions) {
            this.boothInstructions.classList.remove('d-none');
          }
          btn.classList.add('d-none');
        }
    })

  }

}
